(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeConversionReport', EmployeeConversionReport);

    EmployeeConversionReport.$inject = ['$resource'];

    function EmployeeConversionReport ($resource) {
        var resourceUrl =  'api/report/employee-conversion/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
